export const isYoutubeLink = (link: string) => {
  return (
    link.startsWith("https://youtu.be") ||
    link.startsWith("http://youtu.be") ||
    link.startsWith("http://www.youtube.com") ||
    link.startsWith("https://www.youtube.com")
  );
};

const isShortYoutubeLink = (link: string) => {
  return (
    link.startsWith("https://youtu.be") || link.startsWith("http://youtu.be")
  );
};

export const getYoutubeId = (link: string) => {
  if (isShortYoutubeLink(link)) {
    return link.split("/")[3];
  }
  return link.split("v=")[1];
};
